<template>
  <ul class="tags" v-if="keywords"> 
    <li v-for="keyword in keywords" v-bind:key="keyword"> <a @click="type === 'organisation' ? searchOrganisation(keyword)
          : type === 'recipe' ? searchRecipes(keyword)
          : type === 'ingredient' ? searchIngredients(keyword) : null">{{ keyword }}</a></li>
  </ul>   
 <!-- <div v-if="keywords">
    <font-awesome-icon icon="tags" class="mr-2"/>
    <span v-for="keyword in keywords" v-bind:key="keyword"
          @click="type === 'organisation' ? searchOrganisation(keyword)
          : type === 'recipe' ? searchRecipes(keyword)
          : type === 'ingredient' ? searchIngredients(keyword) : null">
      <b-badge pill class="mr-2 bg-orange">{{ keyword }}</b-badge>
    </span>
  </div>-->
</template>

<script>
import SearchPlugin from '../plugins/SearchPlugin'
export default {
  name: 'Keywords',
  props: {
    keywords: Array,
    type: String
  },
  beforeMount () {
    SearchPlugin.event.$on('updateterm', this.changeTerm)
    SearchPlugin.event.$on('showView', this.showView)
  },
  methods: {
    searchOrganisation (keyword) {
      this.searchTerm(keyword, 'Organisations')
    },
    searchRecipes (keyword) {
      this.searchTerm(keyword, 'Recipes')
    },
    searchIngredients (keyword) {
      this.searchTerm(keyword, 'Ingredients')
    },
    changeTerm (val) {
      this.sTerm = val
    },
    showAll: function (token) {
      this.$search.searchNow()
    },
    showSearch: function () {
      this.$search.toggleSearch()
    },
    searchCategory: function (cat_type, token) {
      this.$search.searchNow({
        resulttype: cat_type,
        token: token
      }
      )
    },
    searchTerm: function (term, resulttype, token) {
      this.$search.searchNow({
        term: term,
        resulttype: resulttype,
        token: token
      }
      )
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Keywords.vue